import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable()
export class UserBehaviorService {
  env: any = environment;

  constructor(private http: HttpClient) {}

  getAllProjects(): Promise<any> {
    return this.http
      .get<any>(this.env.managirUrl + "/projects/all", {
        headers: { "Content-Type": "application/json" },
      })
      .toPromise();
  }
  getAllUsers(): Promise<any> {
    return this.http
      .get<any>(this.env.managirUrl + "/users/all", {
        headers: { "Content-Type": "application/json" },
      })
      .toPromise();
  }

  getUser(userId): Promise<any> {
    return this.http
      .get<any>(this.env.managirUrl + "/users/specific/" + userId, {
        headers: { "Content-Type": "application/json" },
      })
      .toPromise();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/user-behavior/user-behavior.service.ts